import * as bootstrap from "bootstrap";
import {CustomValidator} from "./validator";

$(() => {
    const modalElement = document.getElementById('emailSetupModal');
    if (!modalElement) {
        return;
    }

    bootstrap.Modal.getOrCreateInstance(modalElement, {backdrop: 'static', keyboard: false}).show();

    jQuery(document).on('submit', '#emailSetupModal form', function (e) {
        e.preventDefault();
        const $form = $(this);

        $.ajax({
            url: $form.attr('action'),
            data: $form.serialize(),
            method: 'POST',
            success: function () {
                window.location.reload();
            },
            error: function (response) {
                CustomValidator.markErrors(response.responseJSON, $form);
                $form.trigger('interrupted.submit', {submitter: e.submitter});
                $form.trigger(jQuery.Event('form.invalid'));
            }
        });
    });
});
